import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import { fetchInitialData } from "../../fetchData";
import Service from '../../service/Service';
import Cookies from "js-cookie";
import ReviewsData from './common/ReveiwsData';
import * as actions from './actions';
import withContext from "../../../withContext";

const service = new Service();

class Reviews extends Component {
    constructor(props) {
        super(props);
        console.log("Reviews props===>", props);
        let serverSideData = {};
        let initialData = [];
        let reviewsData = [];
        let recipeName = '';
        let metaTitle = '';
        let isApp='';
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        if (serverSideData && serverSideData['msg']==1) {
            initialData = serverSideData;
            reviewsData = serverSideData['result'];
        }
        var recId = "";
        var urlParam = (props.location.pathname + props.location.search);
        if (__isBrowser__) {
            var recId = urlParam.split("recp=")[1];
            if (recId.includes('#')) {
                recId = recId.split('#')[0];
            }
            if (recId.includes('&')) {
                recId = recId.split('&')[0];
            }
        }
        console.log("serverSideData======>", serverSideData, recId);
        if(urlParam.split("/")[3]){
            var hostUrl=urlParam.split("/")[3].split("?");
            recipeName=hostUrl[0].replace(/-/g," ");
            metaTitle = "Reviews: "+recipeName+" - FirstCry Parenting";
        }
        if (this.props.location.search.includes('from=app')) {
            isApp=true;
        }
        this.state = {
            initialData: initialData,
            reviewsData: reviewsData,
            items: [],
            recipeId:recId,
            recipeName: recipeName,
            metaTitle: metaTitle,
            metaDescription: [ ],
            isApp: isApp,
            userName : initialData.userName
        };
        this.qnaPageNo = 1;
        this.totalCount = this.state.initialData.totalcount;
        if (this.props.params.page && this.props.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.params.page);
        }
        this.maxScroll = 0;
        this.timeout = 0;
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
        console.log("authData---",authData);

        console.log("cookieData---",cookieData);
        var LatestFtk = '';
        if (cookieData && (cookieData.includes("app_ftk"))) {
         var cookieAry = cookieData.split(';');
             for (var i = 0; i < cookieAry.length; i++) {
                 if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                    LatestFtk = cookieAry[i].split('app_ftk=')[1];
                 }         
             }         
         }
         console.log("LatestFtk=====>",LatestFtk);
        // var recipeName=reqUrl.split("/")[3];
        // if (cookieData && (cookieData.includes(recipeName))) {
        //     var cookieAry = cookieData.split(';');
        //     for (var i = 0; i < cookieAry.length; i++) {
        //         if (cookieAry[i] && cookieAry[i].includes(recipeName)) {
        //             var _recipeId = cookieAry[i].split(recipeName+'=')[1];
        //         }
        //     }

        // }
        var recId = reqUrl.split("recp=")[1];
        if (recId.includes('#')) {
            recId = recId.split('#')[0];
        }
        if (recId.includes('&')) {
            recId = recId.split('&')[0];
        }
        console.log("_recipeId======>", recId);
        var url = global.api_url + "dietplan/getreviewdetails";
        var header = {
            'Content-Type': 'application/json',
            'ftk': (ftk!="")?ftk:LatestFtk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let body = JSON.stringify({"recipeid":recId, "pageno":"1","pagesize":"10"});
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        console.log("reviewsData=========>", this.state.reviewsData);
        this.setState({ windowWidth: window.outerWidth });
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        document.addEventListener("click", this.domClick);
        if(!global.ftk){
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/");
        }
        if (this.state.isApp) {
            document.querySelector('.sub-container').style.marginBottom = "0";
            var minheightdata = window.innerHeight-50;
            document.querySelector('.data-container').style.minHeight = minheightdata + "px";
            document.querySelector('.main-container').style.background = "#eee";
            actions.loadCallbackFile();
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.reviewsData();

            } else {
                localStorage.setItem('AllreviewsData', JSON.stringify(this.state.initialData));
            }

        } else {
            if (localStorage.getItem('AllreviewsData')) {
                this.setState({
                    initialData: JSON.parse(localStorage.getItem('AllreviewsData')),
                    userName : JSON.parse(localStorage.getItem('AllreviewsData'))['userName'],
                    reviewsData: JSON.parse(localStorage.getItem('AllreviewsData'))['result']
                }, () => { service.loadImages(); });
                this.totalCount = JSON.parse(localStorage.getItem('AllreviewsData'))['totalcount'];
            }
            service.hideLoader();
        }
        this.loadReadMore();

    }

    domClick(event) {
        console.log("event Dom========>", event.target)
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
        }
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", this.domClick);  
    }
    reviewsData() {
        var url = global.api_url + "dietplan/getreviewdetails";
        // var url = global.api_ci_url + "MealPlanner/getReviewDetails";
        // var recipeName=service.genquestionurl(this.state.recipeName);
        // var reciId = Cookies.get(recipeName);
        var postData = {
            "recipeid": this.state.recipeId,
            "pageno":"1",
            "pagesize":"10"
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ initialData: json, userName: json.userName, reviewsData: json['result'] }, () => {
                    service.hideLoader();
                });
                this.totalCount = json['totalcount'];
            }
            service.hideLoader();
            this.loadReadMore();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('data-container')[0]) {
                var cS = document.getElementsByClassName('data-container')[0].offsetTop;
                var cH = document.getElementsByClassName('data-container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                    var checkVal = _this.state.isApp ? ((window.innerHeight + window.scrollY) > document.body.offsetHeight):( (window.innerHeight + window.scrollY) >= document.body.offsetHeight);
                if (!(checkVal) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.qnaPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.qnaPageNo;
                        service.showLoader();
                        service.showTracking();
                        document.getElementById('pgNo').value = _this.qnaPageNo;
                        _this.reviewsDataScroll(_this.qnaPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }
    reviewsDataScroll(pageNo,pageSize) {
        // var url = global.api_url + "dietplan/getreviewdetails";
        var url = global.api_ci_url + "MealPlanner/getReviewDetails";
        // var recipeName=service.genquestionurl(this.state.recipeName);
        // var reciId = Cookies.get(recipeName);
        var postData = {
            "recipeid": this.state.recipeId,
            pageno:pageNo,
            pagesize:pageSize
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == 1) {
                if (this.state.reviewsData.length > 0) {
                    if (pageSize == (pageNo * 10)) {
                        this.setState({ reviewsData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.reviewsData;
                        this.setState({ reviewsData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                } else {
                    localStorage.setItem('initialData', JSON.stringify(json));
                    localStorage.setItem('reviewsData', JSON.stringify(json['result']));
                    this.totalCount = parseInt(json['totalcount']);
                    this.setState({ reviewsData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            this.loadReadMore();
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    openMealPopupSlider(event, e) {
        document.querySelector('.mp-slider').style.display = 'none';
        for (let i = 1; i < 4; i++) {
            if (document.getElementById('mp-slider' + i).style.display == 'block') {
                document.getElementById('mp-slider' + i).style.display == 'none';
            }
        }
        if (e == 'up') {
            document.getElementById('mp-slider' + event).style.display = 'block';
            document.getElementById('mpup' + event).style.display = 'none';
            document.getElementById('mpdown' + event).style.display = 'block';
        } else {
            document.getElementById('mpdown' + event).style.display = 'none';
            document.getElementById('mp-slider' + event).style.display = 'none';
            document.getElementById('mpup' + event).style.display = 'block';
        }
    }
    handdlechange(starrating) {
        var sublist = [];
        if (starrating != 0) {
            for (var i = 0; i < 5; i++) {
                if (i < starrating) {
                    sublist.push(<div key={i} className="rec-star-img left">
                        <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/big-star.png" />
                    </div>);

                } else {
                    sublist.push(<div key={i} className="rec-star-img left">
                        <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                    </div>
                    );

                }

            }
            // sublist=[];
        }
        this.setState({ items: sublist })
    }
    abusePopup(e) {
        if (e.target.classList.contains("abuseicon") && e.target.nextSibling.classList.contains("m-abuse-popup")) {
            var abuseList = document.querySelectorAll(".m-abuse-popup");
            for(var i=0; i<abuseList.length; i++){
                abuseList[i].style.display="none";
            }
            if (e.target.nextSibling.style.display == "none") {
                e.target.nextSibling.style.display = "block";
            } else {
                e.target.nextSibling.style.display = "none";
            }
        }
    }
    changeData(id, type, status) {
        let reviewsData = this.state.reviewsData;
        reviewsData && reviewsData.forEach((review) => {
            if (review.id == id) {
                if (type == "abuse") {
                    if (parseInt(status) == 1) {
                        review.isAbuse = 1;
                    }
                } else {
                    if (parseInt(status) == 1) {
                        review.isLike = 1;
                        review.likecount = parseInt(review.likecount) + 1;
                    }
                }
            }
        });
        service.hideLoader();
        this.setState({ reviewsData: reviewsData });
    }
    isAbuseSet(id) {
        if(this.state.isApp){
            var obj={};
            obj.gaObj = "Meal Planner | Review Page Actions_Report Abuse";
                // "eventdata": {
                //   "event_action": "Report Abuse",
                //   "event_label": ""
                // }
            actions.trackEvent(obj);
        }
        service.showLoader();
        // var url = global.api_url + "dietplan/setabusemark";
        var url = global.api_ci_url + "MealPlanner/setAbuseMark";
        var postData = {
            "id": id,
            "status": 1
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.changeData(id, "abuse", 1);
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    likeArticle(id) {
        if(this.state.isApp){
            var obj={};
            obj.gaObj = "Meal Planner | Review Page Actions_Like";
                // "eventdata": {
                //   "event_action": "Like",
                //   "event_label": ""
                // }
            actions.trackEvent(obj);
        }
        service.showLoader();
        // var url = global.api_url + "dietplan/setrecipereviewuserlike";
        var url = global.api_ci_url + "MealPlanner/setRecipereViewuserlike";
        var postData = {
            "reviewId":id,
            "status":1
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.changeData(id, "likeAction", 1);
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    loadReadMore() {
        let readmoreAry = document.getElementsByClassName('more');
        for (let i = 0; i < readmoreAry.length; i++) {
            let maxHeight = 40;
            let dataId = readmoreAry[i].getAttribute('data-id');
            let divHeight = document.getElementById(dataId).children[0].offsetHeight;
            if (divHeight > maxHeight) {
                document.getElementById(dataId).style.height = maxHeight + 'px';
                readmoreAry[i].style.overflow = "hidden";
                readmoreAry[i].nextSibling.innerHTML = '<div className="readmore R13_link dev_rd_mr" onClick="{(e) => actions.seeMoreClick(e,"40px")}">Read More</div>';
            }
        }
    }
    render() {
        return (
            <main className="main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                {!this.state.isApp && 
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={global.redirect_url+"tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Reviews</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Reviews</h1>
                </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                            <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Reviews</span>
                    </div>
                }
                <div className="sub-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container review-container left">
                        <div className="review-main-cont">
                            <ReviewsData reviews={this.state.reviewsData} eleRef={this} isApp={this.state.isApp} userName={this.state.userName}/>
                            <input type="hidden" id="pgNo" value="" />
                        </div>
                    </div>
                </div>
                <div className="share-overlay"></div>
                <div className="new-right-sect">
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(Reviews);
